export default function PHP_preg_replace_callback() {
  return (
    <div>
      <h1>PHP_preg_replace_callback</h1>
    </div>
  );
}
